import { useConfig } from "@/contexts/cdpConfig";
export const useFeatureEnabled = (feature) => {
    const featuresEnabled = useConfig().featuresEnabled;
    if (!(featuresEnabled === null || featuresEnabled === void 0 ? void 0 : featuresEnabled[feature]))
        return false;
    return featuresEnabled[feature];
};
